import { CampaignGroupIdSchema as n } from "@hprofits/shared";
import { PrivilegeEnum as a } from "@hprofits/shared/auth";
import { z as m } from "zod";
import "../common/acl-view.js";
import { ocPrivate as t } from "../common/auth/procedure-builders.js";
import { createCreationResultSchema as p } from "../common/creation-result.js";
import "../common/owner.js";
import { CampaignGroupIdParamSchema as r, ForceActionParamSchema as s } from "../common/params.js";
import "../common/errors/constants.js";
import { inUseError as c, notFoundError as i, expectationFailedError as u, alreadyExistsError as o } from "../common/errors/contract.js";
import "../common/errors/schemas.js";
import "../swagger/security.js";
import { SwaggerTags as e } from "../swagger/tags.js";
import { CampaignCommonMutationSchema as d, CampaignAdminMutationSchema as g, CopyCampaignSchema as h, RenameCampaignSchema as C, CreateCampaignSchema as S, CampaignStatisticsSchema as A, CampaignSchema as I, CampaignListQuerySchema as f, CampaignListSchema as y } from "./schemas.js";
const l = m.union([
  d.unwrap().extend({
    campaignId: r.shape.campaignId
  }),
  g.unwrap().extend({
    campaignId: r.shape.campaignId
  })
]), D = {
  campaign: {
    /**
     * List campaigns
     *
     * Returns a paginated list of campaigns filtered by id or name, owner,
     * recent-creation window (last 7 days), and ad unit types.
     */
    findAll: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/campaigns",
      summary: "List campaigns",
      description: "Returns a paginated list of campaigns filtered by id or name (comma-separated terms), owner, recent-creation window (last 7 days), and ad unit types.",
      tags: [e.CAMPAIGNS.name]
    }).input(f).output(y).errors({}),
    /**
     * Get a campaign by ID
     */
    findOne: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/campaigns/{campaignId}",
      summary: "Get a campaign by ID",
      tags: [e.CAMPAIGNS.name]
    }).input(r).output(I).errors({
      ...i("Campaign not found")
    }),
    /**
     * Get campaign statistics data for Campaign Statistics block
     */
    getStatistics: t([a.ReadAdvert]).route({
      method: "GET",
      path: "/campaigns/{campaignId}/statistics",
      summary: "Get campaign statistics data",
      description: "Returns target groups, creative groups metadata, and ad groups with pricing rules for Campaign Statistics block",
      tags: [e.CAMPAIGNS.name]
    }).input(r).output(A).errors({
      ...i("Campaign not found")
    }),
    /**
     * Create a new campaign
     */
    create: t([a.WriteAdvert]).route({
      method: "POST",
      path: "/campaigns",
      summary: "Create a campaign",
      tags: [e.CAMPAIGNS.name],
      successStatus: 201
    }).input(S).output(p(n)).errors({}),
    /**
     * Update a campaign
     */
    update: t([a.WriteAdvert]).route({
      method: "PUT",
      path: "/campaigns/{campaignId}",
      summary: "Update a campaign",
      tags: [e.CAMPAIGNS.name],
      successStatus: 204
    }).input(l).output(m.void()).errors({
      ...i("Campaign not found")
    }),
    /**
     * Rename a campaign
     */
    rename: t([a.WriteAdvert]).route({
      method: "PATCH",
      path: "/campaigns/{campaignId}",
      summary: "Rename a campaign",
      tags: [e.CAMPAIGNS.name],
      successStatus: 204
    }).input(
      C.unwrap().extend({
        campaignId: r.shape.campaignId
      })
    ).output(m.void()).errors({
      ...i("Campaign not found"),
      ...o("Campaign with this name already exists")
    }),
    copy: t([a.WriteAdvert]).route({
      method: "POST",
      path: "/campaigns/{campaignId}/copies",
      summary: "Copy a campaign with its target, creative and ad groups",
      tags: [e.CAMPAIGNS.name],
      successStatus: 201
    }).input(
      h.unwrap().extend({
        campaignId: r.shape.campaignId
      })
    ).output(p(n)).errors({
      ...i("Campaign not found"),
      ...o("Campaign with this name already exists"),
      ...u("A rule of the campaign cannot be copied")
    }),
    /**
     * Delete a campaign
     */
    remove: t([a.WriteAdvert]).route({
      method: "DELETE",
      path: "/campaigns/{campaignId}",
      summary: "Delete a campaign",
      tags: [e.CAMPAIGNS.name],
      successStatus: 204,
      inputStructure: "detailed"
    }).input(
      m.object({
        params: r,
        query: s
      })
    ).output(m.void()).errors({
      ...i("Campaign not found"),
      ...c("Campaign is used in target groups or ad groups")
    })
  }
};
export {
  D as campaignContract
};
//# sourceMappingURL=contract.js.map
